import { render, staticRenderFns } from "./RelatedArticle.vue?vue&type=template&id=2b5e76fc&"
import script from "./RelatedArticle.vue?vue&type=script&lang=js&"
export * from "./RelatedArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppImg: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppImg.vue').default,CmsRichText: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/cms/CmsRichText.vue').default,CmsLink: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/cms/CmsLink.vue').default})
